import styled from 'styled-components'

const LoadingStyled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 99999;
  cursor: wait;
  color: #39a520;
`

export default LoadingStyled
